export const ACCOUNT_OVERVIEW = 'account.accountOverview';
export const ACCOUNT_ADDRESS_BOOK = 'account.addressBook';
export const GLOBAL_LABELS = 'global';

// account accountOverview
export const lblOverviewHeading = 'lbl_overview_heading';

// global footerDefault
export const lblFooterDefaultReferenceId = 'lbl_footerDefault_referenceId';

// account addressBook
export const ACC_LBL_EDIT_ADDRESS_FORM_HEADING = 'ACC_LBL_EDIT_ADDRESS_FORM_HEADING';
export const ACC_LBL_ADD_ADDRESS_FORM_HEADING = 'ACC_LBL_ADD_ADDRESS_FORM_HEADING';

const AccountOverviewLabels = {
  account: {
    accountOverview: {
      [lblOverviewHeading]: 'ACCOUNT OVERVIEW',
    },
    addressBook: {
      [ACC_LBL_EDIT_ADDRESS_FORM_HEADING]: 'EDIT SHIPPING ADDRESS',
      [ACC_LBL_ADD_ADDRESS_FORM_HEADING]: 'ADD NEW SHIPPING ADDRESS',
    },
  },
  global: {
    footerDefault: {
      [lblFooterDefaultReferenceId]: 'Reference ID :',
    },
  },
};
export default AccountOverviewLabels;
